var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v(_vm._s(_vm.$t('compute.text_600')))]),_c('vxe-grid',{staticClass:"mb-2",attrs:{"resizable":"","data":_vm.nicInfo,"columns":_vm.columns}}),_c('h5',[_vm._v("BMC"+_vm._s(this.$t('compute.text_600')))]),_c('vxe-grid',{staticClass:"mb-2",attrs:{"resizable":"","data":_vm.ipmiList,"columns":_vm.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }